module.exports = __webpack_public_path__ + "img/1700445360836-WhatsApp Image 2023-11-20 at 09.54.06.jpeg.84426aca.webp";